type Props = { playerName: string; visible: boolean };

export function TurnTransition({ playerName, visible }: Props) {
  if (!visible) return null;
  return (
    <div className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center animate-pop-in">
      <div className="bg-white p-8 rounded-3xl border-8 border-green-400 text-center shadow-2xl rotate-1">
        <div className="text-2xl text-gray-500 font-bold mb-2">輪到...</div>
        <div className="text-5xl font-black text-green-600 mb-6 drop-shadow">{playerName}</div>
      </div>
    </div>
  );
}
